export const POIASSETS_STATUS = {
  INITIAL: 'INITIAL',
  REQUESTING: 'REQUESTING',
  DONE: 'DONE'
}

export const CONFIG_TYPES = {
  category: 'category',
  menu: 'menu',
  application: 'application',
  subcategory: 'subcategory'
}
